import React, { useState, useContext, useEffect,useRef } from 'react';
import { Body, Header, Main } from '../NecttosComp/Layout/Layout';
import { Table, Tbody, Td, Th, Thead, Tr } from '../NecttosComp/Table/Table';
import Button from '../NecttosComp/Button/Button';
import Input2 from '../NecttosComp/Input/Input2';
import { NecttosContext } from '../context/NecttosContext';
import { getAxiosTokenInstance } from '../utils/axiosInstance';
import { useQuery } from 'react-query';

const Busconcession = ({ onClose, toast }) => {
	const [travelList, setTravelList] = useState([]);
	const [loading, setLoading] = useState(false);
	const { collegeId } = useContext(NecttosContext);
	const [state, setState] = useState({ batchId: '' });
	const componentRef = useRef();

	// Fetch all classes
	const getClassesList = async ({ queryKey }) => {
		const [_, { collegeId }] = queryKey;
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get('/college/classes/getClass', {
			params: { collegeId, needAll: true },
		});
		if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');
		return resp.data;
	};

	const classQuery = useQuery(['classes', { collegeId }], getClassesList, {
		enabled: !!collegeId,
	});

	// Batch dropdown options
	const batchOptions = React.useMemo(() => {
		if (!classQuery.data?.list) return [];

		const seen = new Set();
		return classQuery.data.list
			.filter((cls) => {
				if (seen.has(cls.batchId)) return false;
				seen.add(cls.batchId);
				return true;
			})
			.map((cls) => ({
				_id: cls.batchId,
				batchName: cls.batchName,
			}));
	}, [classQuery.data]);

	const fetchTravelData = async (batchId) => {
		setLoading(true);
		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.get('/college/classes/getTravelDetails', {
				params: { batchId, collegeId },
			});
			if (response.data.success && response.data.data) {
				const groupedData = response.data.data.reduce((acc, student) => {
					const className = student.className || 'Unknown Class';
					if (!acc[className]) {
						acc[className] = [];
					}
					acc[className].push(student);
					return acc;
				}, {});

				setTravelList(Object.entries(groupedData));
				
			} else {
				toast?.error(response.data.message || 'Failed to fetch travel data');
				setTravelList([]);
			}
		} catch (error) {
			console.error('Error fetching travel data:', error);
			toast?.error('Error fetching travel data');
			setTravelList([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (state.batchId) {
			fetchTravelData(state.batchId);
		}
	}, [state.batchId]);

	const handleResetFilters = () => {
		setState({ batchId: '' });
		setTravelList([]);
	};

	if (classQuery.isLoading) {
		return <div>Loading batches...</div>;
	}

	if (classQuery.error) {
		return <div>Error loading batches: {classQuery.error.message}</div>;
	}

	return (
		<Main height='90vh' width='98vw'>
			<Header>
				<div className='flex justify-between items-center'>
					<h2>Bus Concession</h2>
					<div className='flex gap-2'>
						<Button onClick={handleResetFilters}>Reset Filters</Button>
						<Button type='close' onClick={onClose}>Close</Button>
						<Button type='print' tableRef={componentRef.current} >Print</Button>

					</div>
				</div>
			</Header>
			<Body>
				<div className='mb-4 flex gap-4 items-end'>
					<div className='flex-1'>
						<Input2 type='drop' fieldName='Select Batch*' options={batchOptions} optionKey='_id' optionDisplay='batchName' returnKey='batchId' state={state} setState={setState} didntShowKey className='w-full' />
					</div>
				</div>

	
				<div  ref={componentRef}  className='printable overflow-y-auto'>
					<Table width='100%'>
						<Thead className='fixed top-0 z-10 bg-gray-100 dark:bg-neutral-800'>
							<Tr>
								<Th width='5%' className='py-3 px-4'>
									#
								</Th>
								<Th width='20%' className='py-3 px-4'>
									Travel Start
								</Th>
								<Th width='20%' className='py-3 px-4'>
									Travel To
								</Th>
								<Th width='10%' className='py-3 px-4'>
									Distance (km)
								</Th>
								<Th width='25%' className='py-3 px-4'>
									Student Name
								</Th>
								<Th width='20%' className='py-3 px-4'>
									Mobile
								</Th>
									<Th width='20%' className='py-3 px-4'>
									Admission Number
								</Th>
									<Th width='20%' className='py-3 px-4'>
									Date of Birth
								</Th>
					
									<Th width='20%' className='py-3 px-4'>
							Age
								</Th>
							</Tr>
						</Thead>
						<Tbody>
							{loading ? (
								<Tr>
									<Td colSpan='6' className='text-center py-4'>
										Loading...
									</Td>
								</Tr>
							) : travelList.length === 0 ? (
								<Tr>
									<Td colSpan='6' className='text-center italic py-4'>
										{state.batchId ? 'No travel details found for selected batch' : 'Please select a batch to view travel details'}
									</Td>
								</Tr>
							) : (
								travelList.map(([className, students], index) => (
									<React.Fragment key={index}>
										<Tr className='bg-gray-100 dark:bg-neutral-700 font-semibold'>
											<Td colSpan='6' className='py-2 px-4 text-center'>
												{className} ({students.length} students)
											</Td>
										</Tr>
										{students.map((user, i) => (
											<Tr key={`${index}-${i}`} className='hover:bg-gray-50 dark:hover:bg-neutral-800'>
												<Td width='5%' className='py-2 px-4'>
													{i + 1}
												</Td>
												<Td width='10%' className='py-2 px-4'>
													{user['1_travelStart'] || '-'}
												</Td>
												<Td width='10%' className='py-2 px-4'>
													{user['1_travelTo'] || '-'}
												</Td>
												<Td width='10%' className='py-2 px-4'>
													{user['1_km'] || '-'}
												</Td>
												<Td width='10%' className='py-2 px-4'>
													{user.name || 'Unknown'}
												</Td>
												<Td width='10%' className='py-2 px-4'>
													{user.phoneNumber || '-'}
												</Td>
													<Td width='10%' className='py-2 px-4'>
													{user.admisionNo || '-'}
												</Td>
												<Td width='10%' className='py-2 px-4'>
													{user.dob || '-'}
												</Td>
												<Td width='10%' className='py-2 px-4'>
													{user.age || '-'}
												</Td>
											</Tr>
										))}
									</React.Fragment>
								))
							)}
						</Tbody>
					</Table>
				</div>

				{/* Summary */}
				{travelList.length > 0 && (
					<div className='mt-4 p-4 bg-gray-50 dark:bg-neutral-800 rounded'>
						<p className='text-sm text-gray-600 dark:text-gray-400'>
							Total Classes: <strong>{travelList.length}</strong> | Total Students: <strong>{travelList.reduce((sum, [_, students]) => sum + students.length, 0)}</strong>
						</p>
					</div>
				)}
			</Body>
		</Main>
	);
};

export default Busconcession;
